<template>
  <div class="page-header" :class="{ 'page-header-promotion': isCategoryPage }">
    <template v-if="!isCategoryPage">
      <div class="home">
        <BaseImg
          class="wrapper-tooltip__icon"
          src="/assets/images/components/mobile/icon-back.svg"
          alt="icon tooltip"
          @click="onBack()"
        />
      </div>
      <div class="title">{{ title }}</div>
    </template>
    <template v-else>
      <BaseImg
        id="logo-mobile"
        class="logo"
        :src="`${PATH_BRAND}logo.webp`"
        alt=""
        @click="onClickLogoHeader"
      />
    </template>
    <div v-if="guidePath" class="guide" @click="router.push(guidePath)">Hướng dẫn</div>
    <div v-if="isShowTooltip" v-click-outside="onClickOutSideTooltip" class="wrapper-tooltip">
      <BaseImg
        class="wrapper-tooltip__icon"
        src="/assets/images/icon/help.svg"
        alt="icon tooltip"
        @click="handleTooltip()"
      />
      <div v-if="isShowContentTooltip" class="wrapper-tooltip__text d-flex">
        <span class="icon icon-warning-black" />
        <div class="wrapper-tooltip__content">
          <div class="heading">{{ dataTooltip?.heading }}</div>
          <div class="sub-text">{{ dataTooltip?.subText }}</div>
        </div>
      </div>
    </div>
    <div v-if="showHomeFromPage" class="home">
      <BaseImg
        class="wrapper-tooltip__icon icon-home"
        src="/assets/images/icon/icon-home.svg"
        alt="icon tooltip"
        @click="goHome()"
      />
    </div>
    <div v-if="showHome" class="home">
      <BaseImg
        class="wrapper-tooltip__icon icon-home"
        src="/assets/images/icon/icon-home.svg"
        alt="icon tooltip"
        @click="goHome()"
      />
    </div>
    <div v-if="showClose" class="home">
      <BaseImg
        class="wrapper-tooltip__icon"
        src="/assets/images/components/mobile/icon-close.svg"
        alt="icon tooltip"
        @click="closeMenu()"
      />
    </div>
    <div v-if="showFilter" class="home">
      <BaseImg
        src="/assets/images/icon/icon-filter-schedule.svg"
        alt="icon-filter"
        class="icon-filter"
        @click="actionFilter"
      />
    </div>
    <div v-if="showAuthen" class="header-button" :class="{ 'header-button-promotion': isCategoryPage }">
      <UserNotLogin v-if="!currentUser" />
      <UserLogged v-if="currentUser" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import UserNotLogin from '~/components/mobile/header/user-not-login.vue'
import UserLogged from '~/components/mobile/header/user-logged.vue'
import { useAppStore } from '~/store/app'
import { usePromotionStore } from '~/store/promotion'
import { PAGE_URLS, ACCOUNT_URLS } from '~/config/page-url'
import { useToggleMenu } from '~/composables/useToggleMenu'
import { PATH_BRAND } from '~/constants/path'

const emit = defineEmits(['filter'])
const { $pinia } = useNuxtApp()
const appstore = useAppStore($pinia)
const { $state } = useAppStore($pinia)
const store = usePromotionStore($pinia)
const { openDepositFrom } = storeToRefs(appstore)
const { setDepositFrom, setOpenWithdrawFrom } = appstore
const route = useRoute()
const router = useRouter()
const $router = useRouter()
const { toggleMenuAccount, toggleMenuDeposit, toggleMenuWithdraw, removeMenu } = useToggleMenu()
const currentUser = computed(() => {
  return $state.currentUser
})

interface IProps {
  title: string
  pathBack: string
  guidePath: string
  isReplacePathBack: boolean
  showAuthen: boolean
  isShowTooltip: boolean
  showHome: boolean
  showClose: boolean
  showFilter: boolean
  fromDeposit: boolean
  backBrowser: boolean
  fromWithdraw: boolean
  showHomeFromPage: boolean
  dataTooltip?: {
    heading?: string
    subText: string
  }
  isCategoryPage?: boolean
}
const props = withDefaults(defineProps<IProps>(), {
  title: '',
  pathBack: '',
  guidePath: '',
  isReplacePathBack: false,
  showAuthen: false,
  isShowTooltip: false,
  showHome: false,
  showClose: false,
  showFilter: false,
  fromDeposit: false,
  backBrowser: false,
  showHomeFromPage: false,
  fromWithdraw: false,
  dataTooltip: undefined,
  isCategoryPage: false
})
const targetRoutesOpenMenu = reactive([
  'account-history-transaction',
  'account-profile',
  'account-bank',
  'account-trading-p2p',
  'account-history-bet',
  'account-bonus'
])
const isShowContentTooltip = ref(false)
const handleTooltip = () => {
  isShowContentTooltip.value = !isShowContentTooltip.value
}
const onClickOutSideTooltip = () => {
  isShowContentTooltip.value = false
}

const onClickLogoHeader = () => {
  router.push(PAGE_URLS.HOME)
}
const onBack = () => {
  if (props.backBrowser) {
    if (window.history.length <= 3) {
      if (route?.name === 'khuyen-mai-id' || route?.name === 'khuyen-mai-vip') {
        router.push(PAGE_URLS.PROMOTION)
        return
      }
      if (route?.name === 'tin-tuc-alias') {
        router.push(PAGE_URLS.NEWS)
        return
      }
      if (route?.name === 'gioi-thieu-alias' || route?.name === 'huong-dan-alias') {
        router.push(PAGE_URLS.HOME)
        return
      }
    }
    router.back()
    return
  }
  if (
    openDepositFrom.value === 'home' &&
    (route.path === PAGE_URLS.HOME ||
      route.name === 'casino' ||
      route.name === 'games' ||
      route.name === 'games-lottery')
  ) {
    toggleMenuDeposit()
    setDepositFrom('')
    return
  }

  if (props.fromDeposit) {
    removeMenu()
    toggleMenuAccount()
    return
  }
  if (props.fromWithdraw) {
    removeMenu()
    toggleMenuAccount()
    return
  }

  if (route.path?.includes(ACCOUNT_URLS.DEPOSIT)) {
    router.back()
    removeMenu()
    toggleMenuDeposit()
  }
  if (route.path?.includes(ACCOUNT_URLS.WITHDRAW)) {
    router.back()
    removeMenu()
    toggleMenuWithdraw()
  }
  if (props.pathBack) {
    if (props.isReplacePathBack) {
      router.replace(props.pathBack)
    } else {
      router.back()
    }
  } else {
    handleCategoryActive()
  }
  if (targetRoutesOpenMenu.includes(route.name as string)) {
    setTimeout(() => {
      removeMenu()
      toggleMenuAccount()
    }, 100)
  }
}

const handleCategoryActive = () => {
  const prevCate = store.prevCategoryActive || {}
  if (prevCate.indexList?.length) {
    const prevIndex = prevCate.indexList[prevCate.indexList.length - 1]
    setTimeout(() => {
      const elementList = document.getElementsByClassName(prevCate.classNameList)
      const elementItem = document.getElementsByClassName(prevCate.classNameItem)
      const wrap = elementList?.length ? elementList[0] : null
      const item = elementItem?.length ? elementItem[prevIndex] : null
      if (item && wrap) {
        const position = (item as any).offsetLeft - (wrap as any).offsetWidth / 2 + (item as any).offsetWidth / 2
        wrap.scrollTo({ left: position, behavior: 'smooth' })
        const indexList = prevCate.indexList.slice(0, prevCate.indexList.length - 1)

        store.setPrevCategoryActive({
          indexList,
          classNameList: prevCate.classNameList,
          classNameItem: prevCate.classNameItem
        })
      }
    }, 100)
  }
}
watch(isShowContentTooltip, () => {
  if (isShowContentTooltip.value) {
    setTimeout(() => {
      isShowContentTooltip.value = false
    }, 2000)
  }
})
const goHome = () => {
  router.push({ path: PAGE_URLS.HOME })
  setDepositFrom('')
  if (props.fromDeposit) {
    toggleMenuDeposit()
  } else if (props.fromWithdraw) {
    toggleMenuWithdraw()
  }
}
const closeMenu = () => {
  setDepositFrom('')
  if (props.fromDeposit) {
    toggleMenuDeposit()
    return
  }
  if (props.fromWithdraw) {
    toggleMenuWithdraw()
  }
}

const actionFilter = () => {
  emit('filter')
}

onMounted(() => {
  window.addEventListener('scroll', function () {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      // Scroll to calc the viewport
      window.scrollBy(0, -0.1)
    }
  })
})
</script>
<style src="public/assets/scss/components/mobile/common/page-header/index.scss" scoped lang="scss" />
